export default "__VITE_ASSET__0bba2124__"